import {
  Component, ViewChild, OnInit, Inject 
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import {
  activation_labels,
  TOKEN_EXPIRY_MESSAGE,
} from './utils/constants.helper';
import { MemberUpdateComponent } from './components/member-update/member-update.component';
import { LoginService } from './services/login.service';
import { HelpFAQComponent } from './components/help-faq/help-faq.component';
import { MemberService } from './services/member.service';
import { OtpComponent } from '../sdc/components/otp/otp.component';
import { TermsConditionComponent } from '../sdc/components/terms-condition/terms-condition.component';
import { MemberTypeComponent } from './components/member-type/member-type.component';
import { SetPasswordComponent } from './components/set-password/set-password.component';
import { AuthenticationService } from '../authentication.service';
import { UserDetailsModel, UserDetailsV2Model } from './models/userdetails.model';
import { LABELS } from './utils/labels.helper';

@Component({
  selector: 'app-card-activation',
  templateUrl: './card-activation.component.html',
  styleUrls: ['./card-activation.component.scss'],
})
export class CardActivationComponent implements OnInit {
  @ViewChild(MemberUpdateComponent) memberUpdate!: MemberUpdateComponent;

  @ViewChild(TermsConditionComponent) terms!: TermsConditionComponent;

  @ViewChild(MemberTypeComponent) memberType!: MemberTypeComponent;

  @ViewChild(SetPasswordComponent) setPassword!: SetPasswordComponent;

  @ViewChild('stepper') stepper!: MatStepper;

  protected readonly stepperLabels = LABELS.stepper;

  editable = true;

  userLocation: 'NZ' | 'AU' | null = null;

  userDetails!: UserDetailsModel | UserDetailsV2Model;

  preferredDevice!: string;

  showPasswordForm: boolean = false;

  currentStepLabel: string = '';

  constructor(
    public dialog: MatDialog,
    private loginService: LoginService,
    private memberService: MemberService,
    private authService: AuthenticationService,
    @Inject(Window) private window: Window
  ) {}

  ngOnInit(): void {
    this.loginService.isLoginRedirect.subscribe((detail) => {
      if (detail) {
        this.window.alert(TOKEN_EXPIRY_MESSAGE);
        this.memberUpdate.memberAddressForm.reset();
        this.memberUpdate.memberPreferenceForm.reset();
        this.terms.toggleTermsCheck(false);
        this.memberType.memberTypeForm.reset();
        this.setPassword.memberPasswordForm.reset();
      }
    });
    this.loginService.validatedUserDetails.subscribe((detail) => {
      if (detail) {
        this.userDetails = detail;
        this.userLocation = this.isNZUser(detail) ? 'NZ' : 'AU';
        this.stepper.next();
      }
    });
    this.memberService.activatedMember.subscribe((detail) => {
      if (detail && !detail.hasIdentityAccount) {
        this.showPasswordForm = true;
      }
    });
  }

  openOtpDialog(): void {
    this.loginService.otpServiceData.subscribe((data) => {
      const dialogRef = this.dialog.open(OtpComponent, {
        autoFocus: false,
        disableClose: true,
        data,
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result !== 'cancel') {
          this.authService.setBearerToken(result);
          this.stepper.next();
        }
      });
    });
  }

  openFAQDialog(): void {
    this.dialog.open(HelpFAQComponent, {
      disableClose: true,
    });
  }

  isNZUser(userDetails: UserDetailsModel | UserDetailsV2Model): userDetails is UserDetailsV2Model {
    return 'isNZUser' in userDetails ? userDetails.isNZUser ?? false : false;
  }

  updateCurrentStepLabel(event: StepperSelectionEvent): void {
    this.currentStepLabel = event.selectedStep.label;
  }
}
